module.exports = __webpack_public_path__ + "img/carrusel_3.93eedb87.jpg";